import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constant";
import LogoutConstant from "../../MainFrame/constants/Constants";
import restClient from "../../MainFrame/action/APIClient";

var GetNavigationItemsAction = function () { };

GetNavigationItemsAction.prototype = {
	getNavigation: function (domain, profileId) {
		restClient.getNavigation(domain, profileId, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error,
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.GET_NAVIGATION_ITEMS,
						data: error,
					});
				}
			} else {
				response["status"] = 200;
				AppDispatcher.dispatch({
					actionType: Constant.GET_NAVIGATION_ITEMS,
					data: response,
				});
			}
		});
	},
};

export default new GetNavigationItemsAction();
